import { render, staticRenderFns } from "./RegistrarPonto.vue?vue&type=template&id=3158bf67"
import script from "./RegistrarPonto.vue?vue&type=script&lang=js"
export * from "./RegistrarPonto.vue?vue&type=script&lang=js"
import style0 from "./RegistrarPonto.vue?vue&type=style&index=0&id=3158bf67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports